import {kSystemTexts} from "../../../constants/texts";

export default function MultiplicationGameValidateButton({userAnswer, onKeyPressed}) {
    // Used in games keyboard, to display validate answer button

    // BUILD
    return (
        <div className={`w-full ${isValidateKeyItemDisabled(userAnswer) ? "bg-disabledBlue cursor-not-allowed text-greyLight7" : "bg-callToAction hover:bg-callToActionHover cursor-pointer text-white"} flex justify-center items-center mt-[12px] h-[56px] rounded-[16px]`}
             onClick={() => onKeyPressed(kSystemTexts.validate, userAnswer)}>
                <span className={"font-medium text-[20px]"}>
                    {"Valider"}
                </span>
        </div>
    );

    // ---- Is validate key item disabled
    function isValidateKeyItemDisabled(userAnswer) {
        return userAnswer.length === 0
    }
}